import React from 'react';
import SwitchWithInput from '../SwitchWithInput';
import { RootState } from '../../../redux';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeTotalBarPosition,
  enableDisableTotalChartControlSwitch,
  renameGrandTotal,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { Box, TextField } from '@mui/material';
import { textFieldStyleProps } from '../../ChartOptions/GridAndAxes/GridAndAxes';

/**
 * This setting is for waterfall chart which is visible in chart controls/settings.
 * @returns Enable / Disable switch for showing total settings in waterfall chart, beginning/end buttons to shift total bar position, Rename total input.
 */
const TotalSettings = ({ iconColor }: { iconColor?: string }) => {
  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));
  const dispatch = useDispatch();

  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const isEnabled = chartControls.properties[propKey]?.waterfall?.total?.isEnable;
  const isRight = chartControls.properties[propKey]?.waterfall?.total?.isRight;
  const grandTotalName = chartControls.properties[propKey]?.waterfall?.total?.name;

  const totalBarPosition = [
    { name: 'Beginning', value: false },
    { name: 'End', value: true },
  ];

  const toggleSwitch = () => {
    dispatch(enableDisableTotalChartControlSwitch(propKey, !isEnabled));
  };

  const renderPositions = () => {
    return totalBarPosition.map((item: { name: string; value: boolean }, index: number) => {
      const isSelected = item.value === isRight;
      return (
        <button
          onClick={() => dispatch(changeTotalBarPosition(propKey, item.value))}
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          key={index}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
            color: '#404040',
          }}
        >
          {item.name}
        </button>
      );
    });
  };

  return (
    <div className="optionsInfo">
      <div
        className="optionDescription"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '5px',
          paddingLeft: '0.1rem',
        }}
      >
        <label
          htmlFor="enableDisable"
          className="enableDisableLabel"
          style={{ color: iconColor ? iconColor : '#404040' }}
        >
          Show
        </label>

        <div
          style={{
            width: '50px',
            height: '24px',
            display: 'flex',
            transform: 'translateX(63px)',
            marginBottom: '9px',
          }}
        >
          <SwitchWithInput isChecked={isEnabled} onSwitch={toggleSwitch} />
        </div>
      </div>
      {isEnabled && (
        <>
          <div className="radioButtons" style={{ marginTop: '15px' }}>
            {renderPositions()}
          </div>
          <Box sx={{ marginTop: '1rem' }}>
            <Box
              className="grand-total-rename-heading"
              style={{ color: iconColor ? iconColor : '#404040' }}
            >
              Label Name For Total
            </Box>
            <TextField
              type="text"
              defaultValue={grandTotalName}
              variant="outlined"
              onBlur={(e) => dispatch(renameGrandTotal(propKey, e.target.value))}
              sx={{ width: '100%' }}
              slotProps={{
                input: {
                  ...textFieldStyleProps,
                  sx: {
                    color: iconColor || '#404040',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#2bb9bb',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: iconColor || '#2bb9bb',
                    },
                  },
                },
              }}
            />
          </Box>
        </>
      )}
    </div>
  );
};

export default TotalSettings;
